<div class="copy-button">
  <div>
    <cds-icon class="cursor-pointer" icon="action:duplicate" (click)="copy()"></cds-icon>
  </div>
  @if (isShowCopied) {
  <div class="copied-popup-box">
    <span class="cds-body1-demibold">Copied</span>
  </div>
  }
</div>
